export default "__VITE_ASSET__40c813e7__"